import axios from 'axios'

const origin = process.env.VUE_APP_API_ORIGIN

const post = (path, payload) => axios.post(origin + path, payload).then(response => response.data)

export default {
  validate (token) {
    return post('/account-invitations/validate', { token })
  },
  accept ({ token, password, passwordConfirmation }) {
    return post('/account-invitations/accept', {
      token,
      password,
      passwordConfirmation
    })
  },
  acceptExistingOwnerInvitation ({ token, currentPassword }) {
    return post('/tenant-access-management/owner-invitations/accept-existing', {
      token,
      currentPassword
    })
  }
}
